// useTableStyles.js
import { useMaterialUIController } from "../context";
import { getColorMappings } from "../components/ColorComponent/ColorComponent";

const useTableStyles = () => {
    const [controller] = useMaterialUIController();
    const { sidenavColor } = controller;
    const { barColor, tableBorder } = getColorMappings(sidenavColor);

    const customStyles = {
        table: {
            style: {
                border: `0.5px solid ${tableBorder}`,
            },
        },
        headRow: {
            style: {
                background: barColor,
                borderBottomColor: tableBorder,
            },
        },
        headCells: {
            style: {
                justifyContent: 'flex-start',
                color: 'white',
            },
        },
        rows: {
            style: {
                borderBottom: `0.5px solid ${tableBorder}`,
                borderTop: `0.5px solid ${tableBorder}`,
           

              
            },
        },
        cells: {
            style: {
                borderRight: `0.5px solid ${tableBorder}`,
                borderLeft: `0.5px solid ${tableBorder}`,

            },
        },
    };

    return customStyles;
};

export default useTableStyles;
